import React from 'react';
import config from "../constants/Configs";
import UniqueUserIdService from '../services/uniqueUserId/UniqueUserIdService'
const playerUniqueIdKey = 'unqId';
class RemoteLocalStorage extends React.Component {
    constructor(props) {
        super(props);
        this.ref = React.createRef();
    }

    componentDidMount() {
        window.addEventListener("message", this.receiveMessage, false);
    }

    componentWillUnmount() {
        //Remove generic listeners
        window.removeEventListener("message", this.receiveMessage);
    }

    receiveMessage(event) {

        if (event.data && event.data.Type && event.data.Type === playerUniqueIdKey) {
            UniqueUserIdService.setUniqueUserId(event.data.Data);
        }
    }

    render() {
        return (
            config.REMOTE_LOCAL_STORAGE_URL ? <iframe
                title={'storage'}
                ref={this.ref}
                src={config.REMOTE_LOCAL_STORAGE_URL}
                id="rls"
                width="1"
                style={{ position: 'absolute' }}
                height="1"
                frameBorder="0"
                marginHeight="0"
                marginWidth="0"
            /> : null
        );
    }
}

export default RemoteLocalStorage;